<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-md-12">
        <b-card no-body class="mb-4 border border-success shadow-none">
          <b-card-header class="bg-success" header-tag="header">
            <h6 class="m-0 text-white">
              Dados da Empresa
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">CNPJ</dt>
                  <dd>fsdffds</dd>
                </dl>
                <dl class="col-md-9">
                  <dt class="text-dark">Nome Empresarial</dt>
                  <dd>gsdgf</dd>
                </dl>
              </div>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">Data de Abertura no CNPJ</dt>
                  <dd>gsfdgf</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Regime de Apuração</dt>
                  <dd>dfgsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Optante pelo Simples Nacional</dt>
                  <dd>gsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Município</dt>
                  <dd>sdgfd</dd>
                </dl>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>

        <b-card no-body class="mb-4 border border-success shadow-none">
          <b-card-header class="bg-success" header-tag="header">
            <h6 class="m-0 text-white">
              Contato
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">CNPJ</dt>
                  <dd>fsdffds</dd>
                </dl>
                <dl class="col-md-9">
                  <dt class="text-dark">Nome Empresarial</dt>
                  <dd>gsdgf</dd>
                </dl>
              </div>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">Data de Abertura no CNPJ</dt>
                  <dd>gsfdgf</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Regime de Apuração</dt>
                  <dd>dfgsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Optante pelo Simples Nacional</dt>
                  <dd>gsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Município</dt>
                  <dd>sdgfd</dd>
                </dl>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>

        <b-card no-body class="mb-4 border border-success shadow-none">
          <b-card-header class="bg-success" header-tag="header">
            <h6 class="m-0 text-white">
              Endereço
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">CNPJ</dt>
                  <dd>fsdffds</dd>
                </dl>
                <dl class="col-md-9">
                  <dt class="text-dark">Nome Empresarial</dt>
                  <dd>gsdgf</dd>
                </dl>
              </div>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">Data de Abertura no CNPJ</dt>
                  <dd>gsfdgf</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Regime de Apuração</dt>
                  <dd>dfgsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Optante pelo Simples Nacional</dt>
                  <dd>gsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Município</dt>
                  <dd>sdgfd</dd>
                </dl>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>

        <b-card no-body class="mb-4 border border-success shadow-none">
          <b-card-header class="bg-success" header-tag="header">
            <h6 class="m-0 text-white">
              Dados Fiscais
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">CNPJ</dt>
                  <dd>fsdffds</dd>
                </dl>
                <dl class="col-md-9">
                  <dt class="text-dark">Nome Empresarial</dt>
                  <dd>gsdgf</dd>
                </dl>
              </div>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">Data de Abertura no CNPJ</dt>
                  <dd>gsfdgf</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Regime de Apuração</dt>
                  <dd>dfgsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Optante pelo Simples Nacional</dt>
                  <dd>gsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Município</dt>
                  <dd>sdgfd</dd>
                </dl>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>

        <b-card no-body class="mb-4 border border-success shadow-none">
          <b-card-header class="bg-success" header-tag="header">
            <h6 class="m-0 text-white">
              Sócios
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">CNPJ</dt>
                  <dd>fsdffds</dd>
                </dl>
                <dl class="col-md-9">
                  <dt class="text-dark">Nome Empresarial</dt>
                  <dd>gsdgf</dd>
                </dl>
              </div>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">Data de Abertura no CNPJ</dt>
                  <dd>gsfdgf</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Regime de Apuração</dt>
                  <dd>dfgsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Optante pelo Simples Nacional</dt>
                  <dd>gsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Município</dt>
                  <dd>sdgfd</dd>
                </dl>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>

        <b-card no-body class="mb-1 border border-success shadow-none">
          <b-card-header class="bg-success" header-tag="header">
            <h6 class="m-0 text-white">
              Tabelião
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">CNPJ</dt>
                  <dd>fsdffds</dd>
                </dl>
                <dl class="col-md-9">
                  <dt class="text-dark">Nome Empresarial</dt>
                  <dd>gsdgf</dd>
                </dl>
              </div>
              <div class="row">
                <dl class="col-md-3">
                  <dt class="text-dark">Data de Abertura no CNPJ</dt>
                  <dd>gsfdgf</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Regime de Apuração</dt>
                  <dd>dfgsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Optante pelo Simples Nacional</dt>
                  <dd>gsfdg</dd>
                </dl>
                <dl class="col-md-3">
                  <dt class="text-dark">Município</dt>
                  <dd>sdgfd</dd>
                </dl>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>

      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Dados da Empresa",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Dados da Empresa",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Dados da Empresa',
          active: true,
        },
      ],
      httpSend: false,
      historico: [],
    };
  },
  created() {},
  methods: {}
};
</script>


